var scope_0 = require('/home/runner/work/vibranium/vibranium/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/15cd7fda3eb2a8595211b55155b2df74.js').default;
var scope_1 = require('/home/runner/work/vibranium/vibranium/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    